import { useState } from "react";
import { Button } from "@/components/ui/button";
import { FolderInput, Trash2 } from "lucide-react";
import { CATEGORIES } from "./imageUrl";

export const BulkActionBar = ({ count, onMove, onDelete, onSelectAll, onClear }) => {
  const [category, setCategory] = useState("portraits");
  return (
    <div data-testid="gallery-bulk-bar" className="fixed bottom-5 left-1/2 -translate-x-1/2 z-50 flex flex-wrap items-center gap-3 px-5 py-3 rounded-full bg-charcoal text-ivory shadow-2xl">
      <span data-testid="gallery-bulk-count" className="font-body text-sm whitespace-nowrap">{count} selected</span>
      <button type="button" onClick={onSelectAll} className="font-body text-xs underline text-ivory/70 hover:text-ivory" data-testid="gallery-bulk-select-all">Select all</button>
      <button type="button" onClick={onClear} className="font-body text-xs underline text-ivory/70 hover:text-ivory" data-testid="gallery-bulk-clear">Clear</button>
      <span className="w-px h-6 bg-ivory/20" />
      <select data-testid="gallery-bulk-category" value={category} onChange={(e) => setCategory(e.target.value)} className="bg-white/10 text-ivory text-sm rounded-md px-2 py-1.5 border border-ivory/20">
        {CATEGORIES.map((c) => <option key={c.value} value={c.value} className="text-charcoal">{c.label}</option>)}
      </select>
      <Button size="sm" disabled={!count} onClick={() => onMove(category)} className="bg-champagne-gold text-charcoal hover:bg-champagne h-8 rounded-full" data-testid="gallery-bulk-move">
        <FolderInput className="w-3.5 h-3.5 mr-1" /> Move
      </Button>
      <Button size="sm" variant="destructive" disabled={!count} onClick={onDelete} className="h-8 rounded-full" data-testid="gallery-bulk-delete">
        <Trash2 className="w-3.5 h-3.5 mr-1" /> Delete
      </Button>
    </div>
  );
};
